import React from "react";
import { Dialog } from "Components";
import { useAppDispatch } from "Hooks";
import {
  addRevertOverride,
  removeOverride,
} from "../../store/policyConfigSlice";
import { Policy } from "../../types";
import styles from "./revertPolicy.module.scss";

type RevertPolicyProps = {
  onClose: () => void;
  isOpen: boolean;
  policy: Policy;
};

const RevertPolicy = ({
  onClose,
  isOpen,
  policy,
}: RevertPolicyProps): React.JSX.Element => {
  const dispatch = useAppDispatch();

  const handleRevertClick = () => {
    dispatch(addRevertOverride(policy.id));
    dispatch(removeOverride(policy.id));
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Revert policy overrides"
      confirmText="Revert"
      onConfirm={handleRevertClick}
      onCancel={onClose}
    >
      <span>Are you sure you want to revert this policy?&nbsp;</span>
      <span className={styles.target}>
        {`${policy.id.toUpperCase()} - ${policy.description}`}
      </span>
    </Dialog>
  );
};

export default RevertPolicy;
